var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6366b2228e64fb7a66f054f602ca7b2b51013118"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lacinetek-frontend@codekraft-ka"]={id:"6366b2228e64fb7a66f054f602ca7b2b51013118"};
      